import { isMultiDateComponent } from '../../../libs';
import { FieldType, IConfigField, IValue } from '../../../model';
import MultiDatePicker, { DateObject } from 'react-multi-date-picker';
import DatePanel from 'react-multi-date-picker/plugins/date_panel';

import React from 'react';
import { Input } from 'antd';
import moment, { Moment } from 'moment';

export const MONTHS = [
  '1月',
  '2月',
  '3月',
  '4月',
  '5月',
  '6月',
  '7月',
  '8月',
  '9月',
  '10月',
  '11月',
  '12月',
];

export const WEEKDAYS = ['日', '一', '二', '三', '四', '五', '六'];

interface IPropsDate<T> {
  readonly fieldConfig: IConfigField<T>;
  readonly onChanged: <T>(key: string, value: T) => void;
  readonly selectedValue: IValue;
  readonly isFilterModeView: boolean;
  readonly className?: string;
}

export const DynamicMultiDate = <T,>(props: IPropsDate<T>) => {
  const { isFilterModeView, fieldConfig, selectedValue } = props;

  if (isFilterModeView) {
    const filterOptExtension = isMultiDateComponent(
      fieldConfig.filterOptExtension
    );
    if (!filterOptExtension) {
      return null;
    }

    if (fieldConfig.filter_type === FieldType.date_multiple) {
      const onChangeDate = (value: DateObject[]) => {
        const newValue = value.map((v) => moment(v.format('YYYYMMDD')));
        props.onChanged(fieldConfig.key, newValue);
      };
      const value =
        selectedValue.value?.map(
          (v: Moment) => new DateObject(v.format('YYYYMMDD'))
        ) || '';

      const renderCustomInput = () => {
        return (
          <Input
            value={value}
            placeholder={fieldConfig.name}
            className="multiple-date-input"
            allowClear
          />
        );
      };

      return (
        <>
          <div className="filter-name">{fieldConfig.name}</div>
          <MultiDatePicker
            value={value}
            minDate={filterOptExtension.minDate}
            maxDate={filterOptExtension.maxDate}
            render={renderCustomInput()}
            onChange={onChangeDate}
            format="YYYY-MM-DD"
            multiple={true}
            sort
            plugins={[<DatePanel />]}
            weekDays={WEEKDAYS}
            months={MONTHS}
            className="multiple-date"
          />
        </>
      );
    }
  }

  return <span className={props.className}>{selectedValue.value}</span>;
};
